
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq6xOnilZ264DjdZ5c3I1onlHADTo9QjmQgGtpcj_MR_IMeta } from "/codebuild/output/src2023100283/src/src/pages/faq.vue?macro=true";
import { default as menuD9n1eH9aIwyNzCOnEbYzboUS9wNDFkibqHIqS_1UMysMeta } from "/codebuild/output/src2023100283/src/src/pages/menu.vue?macro=true";
import { default as indexhVBWQvNnxn3j4X6LSqx7TguDY3fsx9uALk4MD_45jtRdEMeta } from "/codebuild/output/src2023100283/src/src/pages/index.vue?macro=true";
import { default as contactIy_fpasDgU9FfpWQurHckiQBnz1s1TpfTjOEcLz9RZsMeta } from "/codebuild/output/src2023100283/src/src/pages/contact.vue?macro=true";
import { default as tutorialed3r_bdX6rammEXwQAskK4J8_45vfK6iVLwUEQyASjza8Meta } from "/codebuild/output/src2023100283/src/src/pages/tutorial.vue?macro=true";
import { default as agreementZaKLXAq4PAegonG6dCnGSbJ6PFK203pHAOGoaiGFa4gMeta } from "/codebuild/output/src2023100283/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass_j2w7qPrXT1g8rrUtKm1NiqXxMZucdZA0y9oYWL0x6MMeta } from "/codebuild/output/src2023100283/src/src/pages/about-pass.vue?macro=true";
import { default as index1K2_45Z7X9iC0vzJOpm4MWPOf1MCywWgaWcxjxXC0rL7gMeta } from "/codebuild/output/src2023100283/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93TV20YZ0vriHHuqK0m4afs4wQwnQocnXXNW7nFwrBTBsMeta } from "/codebuild/output/src2023100283/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceOxKhAUEg3ftaHK2fpZ8Bci9jK348wCAVnQJhYPnzrhgMeta } from "/codebuild/output/src2023100283/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93_45_HeweEIXq0a_45jDff8iocVCY8nbZsFPV5yN51O65_5AMeta } from "/codebuild/output/src2023100283/src/src/pages/notice/[id].vue?macro=true";
import { default as indexBKiGaDwROnc12_Ondg_SQzfzk_vW39hIcUJNNjRXxK4Meta } from "/codebuild/output/src2023100283/src/src/pages/coupon/index.vue?macro=true";
import { default as indexyQNLBNnPs2a9ngjLIZE7HTrx_avWr4mX3NVkfxtN_uIMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/index.vue?macro=true";
import { default as indexf5SNJK6UPDg287G_457ekxDVo4QN8H_dCXerkorIhPXJ8Meta } from "/codebuild/output/src2023100283/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93r4HEhyAvswfbTjevS4uXIGXVIppNiBZin_45SLe71LnBsMeta } from "/codebuild/output/src2023100283/src/src/pages/parking/[id].vue?macro=true";
import { default as indexYzRQ0uQtrk3fyRqEpNy4_45B4GjELshdEpr3ZM9GYtjXEMeta } from "/codebuild/output/src2023100283/src/src/pages/history/index.vue?macro=true";
import { default as index5Fs6UqTY8sn0PdYjiERwbi0y_45n0piXM7yMRjZgVNElEMeta } from "/codebuild/output/src2023100283/src/src/pages/monthly/index.vue?macro=true";
import { default as indexrhZxqnQaz8zvgo9Qo4kZCm5q_451vJcSAivpPeoL3uYpMMeta } from "/codebuild/output/src2023100283/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexx3Y2HfqTO_45g4dcnIHYyA3BgKXbUQL_dABkoKHBmYiwIMeta } from "/codebuild/output/src2023100283/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviPe48_Kuk65LXeqIDNpxFO7sSKIAqw_45MIjy2W0PVzmbUMeta } from "/codebuild/output/src2023100283/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editgrzCgr2b3kmRqXRcOfWm_45MEgdFsBBEogwe6MydWve6oMeta } from "/codebuild/output/src2023100283/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementbs5T0gOA8HWkpMORx2aSb5pHXj9p75IXRbin1UlbL2AMeta } from "/codebuild/output/src2023100283/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexwx390fD2_YCRYGIYWAvk116NqYul5Te_dNk894JwciQMeta } from "/codebuild/output/src2023100283/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d6qzfkUPueWfTJmmTW4X_kWoWJbWLABTetOBUWJSVjfwMeta } from "/codebuild/output/src2023100283/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmfKzZg2KZGRKJv3H9FZl2TBaOckkh6i_vneEvOmRTpf4Meta } from "/codebuild/output/src2023100283/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexaB2TvAvyIHIZRy4e1CqPPVA8fKHfkFxaRKI5KPyaPnAMeta } from "/codebuild/output/src2023100283/src/src/pages/card/create/index.vue?macro=true";
import { default as indexlp6FS2b29xGYn2gKzaJCJiPismS4eDgebAqeUEZhFTEMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmm4MGwqjho8ZiLhy_45PIjscImJgSIJK_45N7RJ01auv6e60Meta } from "/codebuild/output/src2023100283/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmFqkPbmiN3yb0eKuKXQ_UvE9Chnuy0xTIzDVIbsZmbR0Meta } from "/codebuild/output/src2023100283/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeyymCe0QHAGcOWi2kAHCx1VNhfEt2qiTUaPjahCub8HMMeta } from "/codebuild/output/src2023100283/src/src/pages/membership/complete.vue?macro=true";
import { default as registerxTH7FqiQa89B7pARVnyj5hxjR4eFhODsvef8UYYbmRYMeta } from "/codebuild/output/src2023100283/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93xDf5d0551bh1cu13toaVGx8wEPh_456ZNuQV1XvikRydAMeta } from "/codebuild/output/src2023100283/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmAozTsQHsMH69hodMoWgTxZm_68x3CUD22XtQBjZoKT4Meta } from "/codebuild/output/src2023100283/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93_plAizm0XUS7UaQg_wAmLJ96_a0Md6Ci5WA_YeJ4vEEMeta } from "/codebuild/output/src2023100283/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexXQGazh6Zyqc63aURPjLzW4o3HLeGo14qxjqYc_456sjRwMeta } from "/codebuild/output/src2023100283/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code0VP28J7zIoaikdhzuJEfiBN55zUC84ZClDEhFsFIxjkMeta } from "/codebuild/output/src2023100283/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codesNN11SsO3WJyf7Btjd4lVkqLi9ls6sjPZOL5qZsdV4cMeta } from "/codebuild/output/src2023100283/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeu_Gq_fYecDUsIvsc_45zHhMdXi7SvL0YvuTAUax4udlfgMeta } from "/codebuild/output/src2023100283/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerNE1NLmLZAqEHkipmn_cXnQB1NEtO6y_fWrxc2O04X_YMeta } from "/codebuild/output/src2023100283/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeTPRoOEeuf4hnqgatOlE_45LAh4sDHKi7SDElNZDL9IPbIMeta } from "/codebuild/output/src2023100283/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index9OtfIhLI1VP0nNrQe_45LQNGKNlwmftJpu05ibc_M2_jAMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm4w0Cu4KqmQCqExHxcMqmi8VvRLpbrIfPdqEoCGXdBpYMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete4JdWdcaXigjVz5BvR118e1nClXlZD_xxEpITXnjgLRUMeta } from "/codebuild/output/src2023100283/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexZwPKF5qZLnZBNpBSQh78CDLSZEPHY51n4BhW81QncmIMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93lOGcFGUI9WbthevTErFRqsfNjEp_45czCWWHb2wBBPOJoMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeNp57Lfk_45iCQ5Zk4f045_4538nOClRQbb4b5eR8dOBl_45UwMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasEmtaraWH1UyoKup4ON0rU4gXki6PuU_EveMwmsA1YdkMeta } from "/codebuild/output/src2023100283/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplevJbRIfHj99tu0bcH5bWjzgP10oQ04pEHZOtgvpfpm0QMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailME352WIP8rOQEWbuUhqkXiCQWOdC1qkFfNSZsLwNC38Meta } from "/codebuild/output/src2023100283/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm8GJaVqCn_45YZfOOzj2xg8YfLgdU9rGZI1lfBz5dvKMkkMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentH1gdTclG_NqpvzPHZihztajcXZznlBm1UJGo8PevsscMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm5eDNytx3rcToNN2S95V5_VjR4lSEEc5Am7rmUSHjrO4Meta } from "/codebuild/output/src2023100283/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateteif2y5yDqcFUEa1whlioNdS41D4QISn5kQUbqeleWsMeta } from "/codebuild/output/src2023100283/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completerwUkFiFAwW1XbYFh81SsbQdEOxEaKtK5MkKj2iYKNsEMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeO3L1MBiCao8Pm4U9dicuT0nS9Cvi7_SXK8NrToln9zEMeta } from "/codebuild/output/src2023100283/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordc3d89gtHq0NniY_OfS562_XJDt5Fn_451EYdoFAzeDEB0Meta } from "/codebuild/output/src2023100283/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasj1VVPcT3AsuE_45DgLYs66r0I2LmUu9XPbEsSEefSIBcIMeta } from "/codebuild/output/src2023100283/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register375hzuKLT4egblDk0gxXilKIT_45mBwK0kQhA7fdkMtvEMeta } from "/codebuild/output/src2023100283/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codemyL04iu56J1vz9iEEJHkn5kreNpDHbxZzCN8cSCecbUMeta } from "/codebuild/output/src2023100283/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexbixd28QS0mp0AdHRII_45i4xTrnBw7l2lXGlkiSnIJwj8Meta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexLbWfzdRAeCslo7wRZrAGj_S12nGj_68Sy9_ND0icXbwMeta } from "/codebuild/output/src2023100283/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index3HcPMN_45w0T_AxM6uZIZNtvJ_iRzM_45f7Kp_nXa2vMYRwMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexADLod5sDaumnyXek0xm9N86B06r5xF3qev_O311_45w_0Meta } from "/codebuild/output/src2023100283/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateKT_pfTP_45kGJ7Qv7Thj67yEWMKuS_45yvmJ8iweq7F28xMMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete0e8PuIS8kXzoFBX4qR3t5epnQ_wqOloz_454sJebvYhloMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm132cPALJRxl1_459tKQUPJke8r0SeZrOGIXLH6kNgmZEEMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexgKU6_XwllZ3mEiimXiV2dU2L2eow8mOD57iqPjLyk9MMeta } from "/codebuild/output/src2023100283/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeTYNL6tn2fZGiQ0bsHWsyCIoyIG4XquUI9T8IZRBgYLgMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateHOj25g5t7DC4Q3M8Qgty9HM6jbYzKh15YUfHM_45rAaHYMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexFIXwaf00pm5nHFsg1YR_bndq_451zIt4rA1Zdb5S7SxP4Meta } from "/codebuild/output/src2023100283/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexVgu1kUwOmDUpauOuPhFKGRJpmPN3_SZJUGhWTASDSEEMeta } from "/codebuild/output/src2023100283/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completede8P9R0SwRCtERo2_45ZSqQ7KdzQ262PZFNGwX7OxKXAsMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index3k0N_45R9RgH1Q2JfbjFTpLZMbCjqj_45vSvH6Lb0kVlev4Meta } from "/codebuild/output/src2023100283/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeUerex06BmOVb3hqanQXGZbHOMjgmX8MauTlg4mki_45NoMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexCeW8XnwoXakaktxNp_456lt1eSR6wnPkITXcwedEzIHbMMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexPdJCGhgrMKskxcfPpMdNNLg6xWKx529np_45gfomigUfQMeta } from "/codebuild/output/src2023100283/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexsECfGwqlveoEvVFUAfjzcmFpADM4Wkr2us0HDwxaJOwMeta } from "/codebuild/output/src2023100283/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateSk7FuO7HnC2mPqximd_o7UUqp3MZjd6_45apsJGRRVYesMeta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm2O0bOl_ozhHW4aoxVGCBkriQFT_tHN6NaGKgLaD9xp4Meta } from "/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuD9n1eH9aIwyNzCOnEbYzboUS9wNDFkibqHIqS_1UMysMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexhVBWQvNnxn3j4X6LSqx7TguDY3fsx9uALk4MD_45jtRdEMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src2023100283/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexBKiGaDwROnc12_Ondg_SQzfzk_vW39hIcUJNNjRXxK4Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2023100283/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexYzRQ0uQtrk3fyRqEpNy4_45B4GjELshdEpr3ZM9GYtjXEMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2023100283/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexrhZxqnQaz8zvgo9Qo4kZCm5q_451vJcSAivpPeoL3uYpMMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexx3Y2HfqTO_45g4dcnIHYyA3BgKXbUQL_dABkoKHBmYiwIMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexaB2TvAvyIHIZRy4e1CqPPVA8fKHfkFxaRKI5KPyaPnAMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmm4MGwqjho8ZiLhy_45PIjscImJgSIJK_45N7RJ01auv6e60Meta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmFqkPbmiN3yb0eKuKXQ_UvE9Chnuy0xTIzDVIbsZmbR0Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2023100283/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeyymCe0QHAGcOWi2kAHCx1VNhfEt2qiTUaPjahCub8HMMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerxTH7FqiQa89B7pARVnyj5hxjR4eFhODsvef8UYYbmRYMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmAozTsQHsMH69hodMoWgTxZm_68x3CUD22XtQBjZoKT4Meta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code0VP28J7zIoaikdhzuJEfiBN55zUC84ZClDEhFsFIxjkMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codesNN11SsO3WJyf7Btjd4lVkqLi9ls6sjPZOL5qZsdV4cMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeu_Gq_fYecDUsIvsc_45zHhMdXi7SvL0YvuTAUax4udlfgMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerNE1NLmLZAqEHkipmn_cXnQB1NEtO6y_fWrxc2O04X_YMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm4w0Cu4KqmQCqExHxcMqmi8VvRLpbrIfPdqEoCGXdBpYMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete4JdWdcaXigjVz5BvR118e1nClXlZD_xxEpITXnjgLRUMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexZwPKF5qZLnZBNpBSQh78CDLSZEPHY51n4BhW81QncmIMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeNp57Lfk_45iCQ5Zk4f045_4538nOClRQbb4b5eR8dOBl_45UwMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplevJbRIfHj99tu0bcH5bWjzgP10oQ04pEHZOtgvpfpm0QMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailME352WIP8rOQEWbuUhqkXiCQWOdC1qkFfNSZsLwNC38Meta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm8GJaVqCn_45YZfOOzj2xg8YfLgdU9rGZI1lfBz5dvKMkkMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentH1gdTclG_NqpvzPHZihztajcXZznlBm1UJGo8PevsscMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm5eDNytx3rcToNN2S95V5_VjR4lSEEc5Am7rmUSHjrO4Meta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completerwUkFiFAwW1XbYFh81SsbQdEOxEaKtK5MkKj2iYKNsEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeO3L1MBiCao8Pm4U9dicuT0nS9Cvi7_SXK8NrToln9zEMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordc3d89gtHq0NniY_OfS562_XJDt5Fn_451EYdoFAzeDEB0Meta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register375hzuKLT4egblDk0gxXilKIT_45mBwK0kQhA7fdkMtvEMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codemyL04iu56J1vz9iEEJHkn5kreNpDHbxZzCN8cSCecbUMeta || {},
    component: () => import("/codebuild/output/src2023100283/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2023100283/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]